import React from "react";
import SuperUserLicenseDataGrid from "../DataGrids/SuperUserLicenseDataGrid";

export default function LicensesDetailsTable(props) {
  return (
    <SuperUserLicenseDataGrid
      columns={props.cols}
      rows={props.rows}
      columnBands={props.columnBands}
    />
  );
}
